





















































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import ItemData from 'src/assets/ItemData'
import { ItemDataUpdate } from 'src/assets/ItemDataLive'
import { AttendeeResponseResult } from 'src/assets/AttendeeItemData'
import icon from 'components/presenter/item/ItemIcon'
import SessionDuration from 'components/presenter/item/session/SessionDuration.vue'
import SessionStatusIcon from 'components/presenter/item/session/SessionStatusIcon.vue'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import AttendeeResponse from 'components/presenter/item/session/AttendeeResponse.vue'
import api from 'src/assets/api/gql'
import ItemGetData from 'src/graphql/item/ItemGetData.gql'
import { Item, Session, Student } from 'src/graphql/types'

@Component({
  components: {
    SessionDuration,
    SessionStatusIcon,
    DialogFullscreen,
    PersonAvatar,
    AttendeeResponse
  }
})
export default class ItemCourseStudentSessionsListItem extends Vue {
  icon = icon

  @Prop()
  readonly student!: Student

  @Prop()
  readonly attendeeResponseResult!: AttendeeResponseResult

  @Ref()
  readonly dialog!: DialogFullscreen

  get attendee () {
    return this.attendeeResponseResult.attendeeItemData.attendee
  }

  get session () {
    return this.attendee.session
  }

  get topic () {
    return this.session?.topic
  }

  sessionFormatDate () {
    if (this.session?.startedAt) {
      const datetime = new Date(this.session.startedAt as string)
      return date.formatDate(datetime, 'dddd D MMM \'YY, HH:mm')
    } else {
      return this.$t('sessions.notstarted').toString()
    }
  }

  attendeeFormatDate () {
    const datetime = this.attendee.startedAt || (this.session?.startedAt && this.session.startedAt > this.attendee.createdAt ? this.session.startedAt : this.attendee.createdAt)
    return date.formatDate(datetime, 'D MMM \'YY, HH:mm')
  }

  async showResponse () {
    if (this.attendee.session?.topic?.dataGradebook) {
      const { data } = await api.query({
        query: ItemGetData,
        variables: {
          id: this.session?.topicId
        }
      })
      const topicData = new ItemData((data.item?.data || {}) as ItemDataUpdate)
      Object.assign(this.attendee.session.topic.data, topicData)
      delete this.attendee.session.topic.dataGradebook
    }
    this.dialog.show()
  }
}
